import Vue from 'vue'
import store from 'store'
import qs from 'qs'

export default {
    getVoices(rootState, personId, callbacks)  {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: 'La récupération des voix a échoué.',
                type: 'danger'
            });
        };

        Vue.axios.get(rootState.baseUrl + "/common/google-voices", {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    }
}